// extracted by mini-css-extract-plugin
module.exports = {"contentMain":"tuan__contentMain___3vqhR","main":"tuan__main___3DZBT","fixedQrcode":"tuan__fixedQrcode___1bKqC"};